import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { GeneralService } from 'src/app/services/service.index';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-fus-jefatura',
  templateUrl: './fus-jefatura.component.html',
  styleUrls: [],
  providers: [FusService, ReversionService]
})
export class FusJefaturaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  tipo_agregacion_id: number = 1;
  fuses: any[];
  fus: any;
  estadosFilter: any = [];
  estado: number = 11;
  popupVisibleA: boolean = false;
  popupVisibleO: boolean = false;
  popupVisibleR: boolean = false;
  popupVisibleSeg: boolean = false;
  model: any;
  estados: any[] = [{ id: 3, descripcion: 'Observado' }, { id: 4, descripcion: 'Aprobado' }];
  dataResourceObs: any[];
  clicked: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  fusId: number = 0;
  fusReversion: any;
  jusReversion = false;
  hasError: any;
  fusSeg: string = '';
  dataSeg: any = [];
  esNuevaObs: boolean = false;
  gestionSesionU: number;
  mostrar: boolean = false;

  constructor(private route: ActivatedRoute, private _fs: FusService, private _rs: ReversionService, private _gs: GeneralService) {
    this.getEstadosByUsuario();
    this.resetErrors();
    this.getObservacionesLista();
    this.gestionSesionU = JSON.parse(localStorage.getItem('g'));
    let date = new Date();
    if (this.gestionSesionU == date.getFullYear()) {
      this.mostrar = true;
    }
    this.tipo_agregacion_id = 1;
  }

  ngOnInit() {


  }




  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListFus(this.estado, this.tipo_agregacion_id);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.model.observacion = '';
      this.esNuevaObs = true;
    }

    else {
      this.esNuevaObs = false;
      this.model.observacion = esNueva;
    }
  }

  getObservacionesLista() {
    this._gs.getObservaciones('FUS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }


  getListFus(id: number, tipo_agregacion_id: number) {
    this._fs.getListFusByEstadoId(id, tipo_agregacion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.fuses = result.data; }
        else { this.fuses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  refreshDataGrid(e) {
    this.getListFus(e.value, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
    this.estado = e.value;
  }

  aprobarFUS() {
    this.clicked = true;
    this.model.id = this.fusId;
    this._fs.putFusActualizaJefatura(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getListFus(this.estado, this.tipo_agregacion_id);
          this.dataGrid.instance.refresh();
          toastr.success('Datos guardados correctamente.');
          this.clicked = false;
        }
        this.popupVisibleA = false;
      });
  }

  observarFUS() {
    this.model.id = this.fusId;
    if (this.validSave()) {
      this.clicked = true;
      this._fs.putFusActualizaJefatura(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleO = false;
        });
    }
  }

  validSave() {
    let res = true;
    if (this.model.observacion == '') {
      this.hasError.observacion = true; res = false;
    }
    if (this.model.observacion_id == 0) {
      this.hasError.observacion_id = true; res = false;
    }
    if ((this.model.estado_id != 4)) {
      if (this.model.observacion_id == 0) {
        this.hasError.observacion_id = true; res = false;
      }
    }

    return res;
  }

  resetErrors() {
    this.model = { id: 0, observacion: '', estado_id: 0, observacion_id: 0 };
    this.hasError = { observacion: false, observacion_id: false };
  }

  showModalAprobar(id: number) {
    this.popupVisibleA = true;
    this.fusId = id;
    this.model.estado_id = 12;
  }

  showModalObs(id: number) {
    this.resetErrors();
    this.popupVisibleO = true;
    this.fusId = id;
    this.model.estado_id = 13;
  }

  getFusReversionesById(id: string) {
    this.resetErrors();
    this._rs.getFusReversionesById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusReversion = result.data;
          this.popupVisibleR = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveReversion() {
    this.jusReversion = false;
    if (this.validRev()) {
      this._rs.postFusReversion(this.fusReversion).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleR = false;
        });
    }
  }

  validRev() {
    let res = true, f1 = false, f2 = false;
    if (!UtilHelper.validator(this.fusReversion.justifica_reversion, 'text')) {
      f1 = true;;
    }
    this.fusReversion.detalle.forEach(item => {
      if ((item.revertido <= 0))
        f2 = true;
    });

    if (f2) {
      res = false;
      toastr.warning('Los montos no pueden ser ceros');
    }
    if (f1) {
      res = false;
      toastr.warning('Complete la justificación');
    }
    return res;
  }

  showModalSeg(id: string, fus: string) {
    this.fusSeg = fus;
    this._fs.getSeguimientoByFusId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.dataSeg = result.data; }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }

}
